import { FallbackProps } from 'react-error-boundary';
import { Button } from 'yoso';
import { ErrorMessage } from '~/components/Error/Message';
import { EmptyErrorMessage } from '~/components/Error/Message/Empty/EmptyErrorMessage';
import { T } from '~/components/I18n';
import { Section } from '~/components/Page/Section/Section';
import styles from './EvolveErrorFallback.module.scss';

export type EvolveErrorFallbackProps = FallbackProps;
export const EvolveErrorFallback = ({ error }: FallbackProps) => (
  <Section className={styles.root}>
    {(() => {
      switch (error.message) {
        case 'EMPTY':
          return (
            <EmptyErrorMessage
              title={<T name="citizen_evolve_list_empty_title" />}
              description={<T name="citizen_evolve_list_empty_desc" />}
            />
          );
        default:
          return (
            <ErrorMessage
              className={styles.message}
              title={<T name="citizen_error_etc_title" />}
              description={<T name="citizen_error_etc_desc" />}>
              <Button as="a" href="/" size="large" color="secondary">
                <T name="citizen_homebutton" />
              </Button>
            </ErrorMessage>
          );
      }
    })()}
  </Section>
);
